/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { toEventId, type Source } from '@jira/forge__forge-ui-types/src/common/types/analytics.tsx';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import { fireInitializationEvent } from '../../common/utils/consumers/index.tsx';

const INITIALIZATION_ACTIONS = {
	STARTED: 'started',
	FINISHED: 'finished',
	FAILED: 'failed',
} as const;

export const issueViewInitializationId: string = toEventId('issueViewInitialization');
export const fetchModulesInitializationId: string = toEventId('fetchModulesInitialization');

export const fireInitializationFetchFinishedEvent = (
	source?: Source,
	attributes?: Attributes,
	// oxlint-disable-next-line typescript/no-invalid-void-type, @typescript-eslint/no-explicit-any
): Promise<[void, any]> =>
	fireInitializationEvent(INITIALIZATION_ACTIONS.FINISHED, {
		id: fetchModulesInitializationId,
		source,
		attributes,
	});

export const fireInitializationFetchFailedEvent = (
	source?: Source,
	attributes?: Attributes,
	// oxlint-disable-next-line typescript/no-invalid-void-type, @typescript-eslint/no-explicit-any
): Promise<[void, any]> =>
	fireInitializationEvent(INITIALIZATION_ACTIONS.FAILED, {
		id: fetchModulesInitializationId,
		source,
		attributes,
	});

export const fireInitializationIssueViewFinishedEvent = (
	source?: Source,
	attributes?: Attributes,
	// oxlint-disable-next-line typescript/no-invalid-void-type, @typescript-eslint/no-explicit-any
): Promise<[void, any]> =>
	fireInitializationEvent(INITIALIZATION_ACTIONS.FINISHED, {
		id: issueViewInitializationId,
		source,
		attributes,
	});

export const fireInitializationIssueViewFailedEvent = (
	source?: Source,
	attributes?: Attributes,
	// oxlint-disable-next-line typescript/no-invalid-void-type, @typescript-eslint/no-explicit-any
): Promise<[void, any]> =>
	fireInitializationEvent(INITIALIZATION_ACTIONS.FAILED, {
		id: issueViewInitializationId,
		source,
		attributes,
	});
